import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { UNASSIGNED_TECHNICIAN_FILTER } from '@evimo/components/maintenance/work-orders/WorkOrderKanbanPageContainer/utils';

export type FilterOption = { value: string; label: string };

export function useWorkOrderKanbanFilterOptions(args: {
  siteOptions: FilterOption[];
  technicianOptions: FilterOption[];
  planOptions: FilterOption[];
}) {
  const { t } = useTranslation('maintenance');

  const technicianOptions = useMemo(
    () => [
      {
        value: UNASSIGNED_TECHNICIAN_FILTER,
        label: t('workOrders.kanban.filters.unassignedTechnician'),
      },
      ...args.technicianOptions,
    ],
    [args.technicianOptions, t],
  );

  return {
    siteOptions: args.siteOptions,
    technicianOptions,
    planOptions: args.planOptions,
  };
}
